/* This is Computed based on store */

export default {};



// WEBPACK FOOTER //
// ./src/store/getters.js